import { motion } from "framer-motion";

const BAR_COUNT = 42;

export default function Waveform({ active = true }) {
  return (
    <div
      className="flex items-end justify-center gap-[3px] h-24 md:h-28"
      data-testid="waveform"
      aria-hidden
    >
      {Array.from({ length: BAR_COUNT }).map((_, i) => {
        const seed = (Math.sin(i * 0.9) + 1) / 2; // 0..1
        const target = 20 + seed * 90;
        return (
          <motion.span
            key={i}
            className="block w-[3px] md:w-[4px] rounded-full"
            style={{
              background:
                i % 5 === 0
                  ? "linear-gradient(180deg,#ccff00,#ff5a00)"
                  : "linear-gradient(180deg,#ff5a00,#ff5a00)",
              opacity: active ? 1 : 0.4,
            }}
            initial={{ height: 6 }}
            animate={
              active
                ? {
                    height: [8, target, 12, target * 0.6, target, 10],
                  }
                : { height: 6 }
            }
            transition={{
              duration: 1.6 + (i % 6) * 0.15,
              repeat: Infinity,
              ease: "easeInOut",
              delay: i * 0.03,
            }}
          />
        );
      })}
    </div>
  );
}
